import { render, staticRenderFns } from "./LoaderApp.vue?vue&type=template&id=38b714fa&scoped=true&lang=pug"
import script from "./LoaderApp.vue?vue&type=script&lang=ts"
export * from "./LoaderApp.vue?vue&type=script&lang=ts"
import style0 from "./LoaderApp.vue?vue&type=style&index=0&id=38b714fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b714fa",
  null
  
)

export default component.exports